export const TEXTCONSTANTS = {
  notAuthorized:
    // eslint-disable-next-line max-len
    'Welcome to Aposto’s Agency Portal. Please select an option on the left. To upload staff details please select the All Staff option.',
};
